import { authGet } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";

import { Finding } from "@pages/findings/types";

export const fetchDeploymentFinding = (
  deploymentId: string,
  findingId: string
): Promise<Finding> => {
  return authGet<Finding>(
    `${DEPLOYMENT_URL}/${deploymentId}/issues/${findingId}`
  );
};
